<template>
    <InformeCard id="recaudacion-cupones" name="recaudacion-cupones" collapsable="true" title="Transacciones de precios agrupados" class="width-responsive">
        <ContentOrLoading>
            <div v-if="recaudacion_cupones" class="table-responsive">
                <table class="table table-hover text-nowrap">
                    <thead>
                        <tr>
                            <th>Tipo de precio</th>
                            <th>Total transacciones</th>
                            <th>Total recaudado</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(cupon, index) in recaudacion_cupones">
                            <tr :key="index">
                                <td>{{ cupon.name }}</td>
                                <td>{{ cupon.total }}</td>
                                <td>{{ cupon.importe_total | formatear_precio }}</td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </ContentOrLoading>
    </InformeCard>
</template>

<script>
    import InformeCard from "../InformeCard";

    export default {
        props: ['lista_id', 'fecha_inicio', 'fecha_fin'],
        data() {
            return {
                loading: false,
                recaudacion_cupones: null
            }
        },
        created() {
            this.getRecaudacionCupones();
        },
        methods: {
            getRecaudacionCupones() {
                this.loading = true;

                const params = {
                    filters: {},
                    lista_id: this.lista_id,
                };

                if (this.fecha_inicio && this.fecha_fin) {
                    params.filters.fecha_inicio = this.fecha_inicio;
                    params.filters.fecha_fin = this.fecha_fin;
                }

                this.$store.dispatch(this.config.getVuexAlias('back.abonos.desglose-ventas.recaudacion-cupones'), params).then(res => {
                    this.recaudacion_cupones = res.data.data;
                }).finally(() => this.loading = false);
            }
        },
        components: {
            InformeCard
        }
    }
</script>

<style scoped>
     @media (max-width: 700px) {
        .width-responsive {
            width: 320px;
        }
     }
</style>